import React from "react";
import {
  Box,
  Container,
  Flex,
  HStack,
  Button,
  Heading,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import CTAButton from "./CTAButton";

export default function Navbar() {
  const isMobile = useBreakpointValue({ base: true, md: false });

  const navLinks = [
    { label: "Home", to: "/" },
    { label: "Disciplines", to: "/disciplines" },
    { label: "For Students", to: "/for-students" },
    { label: "For Colleges", to: "/for-colleges" },
    { label: "Contact", to: "/contact" },
  ];

  return (
    <Box
      bg="#F0F6FA"
      py={4}
      position="sticky"
      top={0}
      zIndex={10}
      boxShadow="0 2px 10px rgba(0,0,0,0.1)"
      borderBottomWidth="1px"
      borderBottomColor="#E2E8F0"
    >
      <Container maxW="container.xl">
        <Flex justify="space-between" align="center">
          {/* Logo */}
          <Box as={RouterLink} to="/" _hover={{ textDecoration: "none" }}>
            <Heading
              size="md"
              color="#0F172A"
              fontFamily="Merriweather, serif"
            >
              Ojasa Mirai
            </Heading>
            <Box fontSize="xs" color="#475569">
              College Program
            </Box>
          </Box>

          {/* Desktop Navigation */}
          {!isMobile && (
            <HStack spacing={8}>
              {navLinks.map((link) => (
                <Button
                  key={link.to}
                  as={RouterLink}
                  to={link.to}
                  variant="ghost"
                  size="sm"
                  color="#1E293B"
                  _hover={{
                    color: "#10B981",
                  }}
                >
                  {link.label}
                </Button>
              ))}
            </HStack>
          )}

          {/* Right Side - CTA */}
          <HStack spacing={4}>
            {!isMobile && (
              <CTAButton to="/for-colleges" size="sm">
                Partner With Us
              </CTAButton>
            )}
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
}
